import { Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { axiosGet } from "../../../main/app-axios";
import consts from "../../../main/consts";
import { showMessage } from "../../../state/app/appActions";
import DashboardErrorState from "./components/DashboardErrorState/DashboardErrorState";
import DashboardHeader from "./components/DashboardHeader/DashboardHeader";
import OrdersTable from "./components/OrdersTable/OrdersTable";
import ProgressSummary from "./components/ProgressSummary/ProgressSummary";
import DashboardSkeleton from "./components/Skeleton/Skeleton";
import StatusCard from "./components/StatusCard/StatusCard";
import SummaryCard from "./components/SummaryCard/SummaryCard";
import WithdrawalAlert from "./components/WithdrawalAlert/WithdrawalAlert";
import { statusRoutes, tableDetailPages } from "./constants";
import useStyles from "./index.styles";

export default function Dashboard() {
	const classes = useStyles();
	const history = useHistory();
	const dispatch = useDispatch();
	const [searchTerm, setSearchTerm] = useState("");
	const [dashboard, setDashboard] = useState();
	const [dashboardHeader, setDashboardHeader] = useState();
	const [isLoadingDashboard, setIsLoadingDashboard] = useState(true);
	const [hasError, setHasError] = useState(false);

	const fetchDashboardData = () => {
		setIsLoadingDashboard(true);
		setHasError(false);
		axiosGet("/pedido/count", { dashboard: true }, dispatch)
			.then((response) => {
				if (response && response.status === 200) {
					const { header, ...dashboard } = response.data.dashboard;

					setDashboard(dashboard);
					setDashboardHeader(header);
					setHasError(false);
				} else {
					setHasError(true);
					dispatch(
						showMessage(
							"Não foi possível carregar os dados do dashboard.",
							"error",
						),
					);
				}
			})
			.catch(() => {
				setHasError(true);
				dispatch(
					showMessage(
						"Erro de comunicação com o servidor ao atualizar dashboard.",
						"error",
					),
				);
			})
			.finally(() => {
				setIsLoadingDashboard(false);
			});
	};

	useEffect(() => {
		fetchDashboardData();
	}, []);

	const goToStatusList = (status) => {
		const route = statusRoutes[status];
		if (route) history.push(`${consts.CONTEXT}${route}`);
	};

	const goToOrderDetails = (type, orderId) => {
		const page = tableDetailPages[type] || "all-orders";
		history.push(`${consts.CONTEXT}/${page}/${orderId}`, {
			data: { page },
		});
	};

	const goToAllOrdersSearch = () => {
		history.push(`${consts.CONTEXT}/all-orders`, {
			find: searchTerm.trim(),
		});
	};

	const refreshUpdatedAt = () => {
		fetchDashboardData();
	};

	if (isLoadingDashboard) {
		return <DashboardSkeleton />;
	}

	if (hasError && !isLoadingDashboard) {
		return <DashboardErrorState onRetry={fetchDashboardData} />;
	}

	return (
		<div className={classes.root}>
			<DashboardHeader
				currentDate={dashboardHeader?.date}
				updatedAt={dashboardHeader?.updatedAt}
				searchTerm={searchTerm}
				searchPlaceholder={dashboardHeader?.searchPlaceholder}
				onSearchChange={setSearchTerm}
				onSearchSubmit={goToAllOrdersSearch}
				onRefresh={refreshUpdatedAt}
			/>

			<div className={classes.rows}>
				<Grid container spacing={2}>
					{dashboard?.summaryCards.map((card) => {
						return (
							<Grid item xs={4} key={card.id}>
								<SummaryCard card={card} />
							</Grid>
						);
					})}
				</Grid>

				<Grid container spacing={2}>
					<Grid item xs={12} lg={8}>
						<ProgressSummary data={dashboard?.ordersInProgress} />
					</Grid>
					<Grid item xs={12} lg={4}>
						<div className={classes.statusCardsWrapper}>
							{dashboard?.statusCards.map((card) => (
								<div className={classes.statusCardsItem} key={card.status}>
									<StatusCard
										card={card}
										onClick={() => goToStatusList(card.status)}
									/>
								</div>
							))}
						</div>
					</Grid>
				</Grid>

				<Grid container spacing={2}>
					<Grid item xs={12} lg={6}>
						<OrdersTable
							table={dashboard?.tables.expiring}
							type="expiring"
							isEmpty={dashboard?.tables.expiring.rows.length === 0}
							onRowClick={(orderId) => goToOrderDetails("expiring", orderId)}
						/>
					</Grid>
					<Grid item xs={12} lg={6}>
						<OrdersTable
							table={dashboard?.tables.overdue}
							type="overdue"
							isEmpty={dashboard?.tables.overdue.rows.length === 0}
							onRowClick={(orderId) => goToOrderDetails("overdue", orderId)}
						/>
					</Grid>
				</Grid>

				<WithdrawalAlert
					data={dashboard?.tables.withdrawal}
					isEmpty={dashboard?.tables.withdrawal?.rows.length === 0}
					onRowClick={(orderId) => goToOrderDetails("withdrawal", orderId)}
				/>
			</div>
		</div>
	);
}
